import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            dark: {
                primary: '#3f51b5',
                secondary: '#b0bec5',
                anchor: '#8c9eff',
            },
        },
    },
});